export abstract class ChannelMapperStrategyAbstract {
  public abstract remapChannelNumber(totalNumberOfChannels: number, channelNumber: number): number
  public remapChannelIndex(totalNumberOfChannels: number, channelNumber: number): number {
    return this.remapChannelNumber(totalNumberOfChannels, channelNumber + 1) - 1
  }
}
